module.exports = "<div class=\"calendar-display\">\n  <div class=\"calendar-month-year\">{{monthYear}}</div>\n  <div class=\"calendar-weekdays\">\n    <span ng-repeat=\"wd in weekDays\">{{wd}}</span>\n  </div>\n  <div class=\"calendar-days\">\n    <span class=\"padding-day\" ng-repeat=\"d in prePadDays\">{{d}}</span>\n    <span ng-repeat=\"d in days\" class=\"{{dayInRange(d.date) ? 'hilighted-day' : ''}}\">{{d.num}}</span>\n    <span class=\"padding-day\" ng-repeat=\"d in postPadDays\">{{d}}</span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/directives/calendar-view/calendar-view.html
// module id = 477
// module chunks = 22